import Column3dGroup from '../datasets/groups/column.3d';
import { pluckNumber, componentFactory, datasetFactory } from '../lib/lib';
/**
 * function to  create dataset.
 * assign dataset to vCanvas.
 **/
export default function (chart) {
  let children = chart.getChildren(),
    chartAttr = chart.getFromEnv('chart-attrib'),
    canvas = children.canvas[0],
    datasetParent = canvas.getChildren('vCanvas'),
    dataObj = chart.getFromEnv('dataSource'),
    dataset = dataObj.dataset,
    showCumulativeLine = pluckNumber(chartAttr.showcumulativeline, 1),
    data = dataObj.data || (dataset && dataset[0].data),
    DSClass,
    groupManager3d,
    datasetJSON;

  datasetJSON = {
    data: data
  };

  if (!(data && data.length !== 0)) {
    chart.setChartMessage();
    return;
  }
  DSClass = chart.getDSdef('column');

  if (chart.config.is3D) {
    componentFactory(datasetParent[0], Column3dGroup, 'datasetGroup_column');
    groupManager3d = datasetParent[0].getChildren('datasetGroup_column')[0];
  }

  datasetFactory(groupManager3d || datasetParent[0], DSClass, 'dataset', 1, [datasetJSON]);
  if (showCumulativeLine) {
    DSClass = chart.getDSdef('line');
    datasetFactory(datasetParent[1], DSClass, 'dataset', 1, [datasetJSON], [1]);
  }
}
